import { render, staticRenderFns } from "./SingleEntries.vue?vue&type=template&id=bfd34990&"
import script from "./SingleEntries.vue?vue&type=script&lang=js&"
export * from "./SingleEntries.vue?vue&type=script&lang=js&"
import style0 from "./SingleEntries.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import DataCard from '@/components/shared/DataCard.vue'
import DataCardSearchField from '@/components/shared/DataCardSearchField.vue'
import HasyDataTable from '@/components/shared/HasyDataTable.vue'
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {DataCard,DataCardSearchField,HasyDataTable,VAutocomplete,VBtn,VContainer,VFlex,VIcon,VLayout,VList,VListTile,VListTileTitle,VMenu,VTextField})
